export default __webpack_public_path__ + "static/media/andrew_pattison.d35a170a.jpg";